export function play($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    $($name).click(function(e) {
        e.preventDefault();

        let that = $(this);

        const href = that.data('href');

        let audios = window.audios ? window.audios : {};

        audios = stopAllAudios(audios, $name, this);

        if (!audios || !audios[href]) {
            audios[href] = new Audio(href);
            audios[href].volume = 0.5;
        }

        audios[href].onended = function() {
            that.removeClass('is-playing');
            window.audios[href].currentTime = 0;
        };

        audios[href].onpaused = function() {
            that.removeClass('is-playing');
            window.audios[href].currentTime = 0;
        };

        audios[href].currentTime = 0;

        that.toggleClass('is-playing');

        if (!that.hasClass('is-playing')) {
            audios[href].pause();
            return;
        }

        audios[href].play();

        window.audios = audios;
    })
}

function stopAllAudios(audios, $name, that) {
    $($name).not(that).removeClass('is-playing');

    $.each(audios, function (i, audio) {
        audio.pause();
    });

    return audios;
}
